import React from "react";
import { Route } from "react-router-dom";
import SidebarNavList from "./SidebarNavList";
import {
  AdministratorMenu,
  IssuerMenu,
  StoreMenu,
  ManagerMenu,
  ChargeManagerMenu,
} from "./Menu";
import { getViewType } from "../../Config/viewType";

class SidebarNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: -1,
      clicked: -1,
    };
    // AdminInfo 조회가 실패하면(서버 스키마 불일치 등) 사이드바가 앱 전체를
    // 흰 화면으로 만들었다. 메뉴가 비는 것으로 그치도록 방어한다.
    const adminInfo = (props.userData && props.userData.AdminInfo) || {};
    // 로컬푸드(deliveryStore) 권한이 없으면 "로컬푸드 구독" 메뉴 숨김
    const storeMenu = adminInfo.isDeliveryStore
      ? StoreMenu
      : StoreMenu.filter((m) => m.title !== "로컬푸드 구독");
    // 로그인 시 선택한 유형 기준으로 메뉴 결정(가맹점·회비담당 겹침 해소)
    const viewType = getViewType(adminInfo);
    this.menus =
      (viewType === "Administrator" && AdministratorMenu) ||
      (viewType === "Issuer" && IssuerMenu) ||
      (viewType === "Manager" && ManagerMenu) ||
      (viewType === "ChargeManager" && ChargeManagerMenu) ||
      (viewType === "Store" && storeMenu) ||
      [];
  }

  handleExpand(e, i, match) {
    e.preventDefault();

    if (this.state.clicked === -1 && match) {
      this.setState((state) => ({
        active: -1,
        clicked: 1,
      }));
    } else {
      this.setState((state) => ({
        active: this.state.active === i ? -1 : i,
        clicked: 1,
      }));
    }
  }

  render() {
    return (
      <ul className="nav">
        {this.menus.map((menu, i) => {
          return (
            <Route
              key={i}
              path={menu.path[0]}
              exact={menu.exact}
              children={({ match }) => {
                return (
                  <SidebarNavList
                    data={menu}
                    key={i}
                    expand={(e) => this.handleExpand(e, i, match)}
                    active={i === this.state.active}
                    clicked={this.state.clicked}
                  />
                );
              }}
            />
          );
        })}
      </ul>
    );
  }
}

export default SidebarNav;
